import type {
  GroupingField,
  ReportField,
  SortField,
  TabularRow,
  TabularSnapshot,
} from "../../../../../../../../api/types/svTypes.ts";
import type { ResponseColumn } from "../../../../utilities/gridStateHelper.ts";

interface DisplayedResult {
  rows: TabularRow[];
  snapshot?: TabularSnapshot;
  columns: ResponseColumn[] | undefined;
  fields: ReportField[];
  sorts: SortField[];
  groupingFields: GroupingField[];
}

export interface TabularDisplayState {
  result: DisplayedResult;
  revision: number;
}

export const updateTabularDisplayState = (
  previous: TabularDisplayState | undefined,
  next: DisplayedResult
): TabularDisplayState => {
  if (previous?.result.rows === next.rows && previous.result.snapshot?.resultId === next.snapshot?.resultId) {
    return previous;
  }
  return {
    revision: previous ? previous.revision + 1 : 0,
    result: {
      rows: next.rows,
      snapshot: next.snapshot,
      columns: next.columns,
      fields: next.fields,
      sorts: next.sorts,
      groupingFields: next.groupingFields,
    },
  };
};

export const orderDisplayedColumns = (
  displayed: ResponseColumn[] | undefined,
  requested: ResponseColumn[] | undefined
): ResponseColumn[] | undefined => {
  if (!displayed || !requested || displayed.length !== requested.length) {
    return displayed;
  }
  const byId = new Map(displayed.map((column) => [column.id, column]));
  const ordered = requested.map((column) => byId.get(column.id));
  if (ordered.some((column) => column === undefined)) {
    return displayed;
  }
  return ordered.filter((column): column is ResponseColumn => column !== undefined);
};
